import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { POST_CategoryInsert } from "../../../helpers/url_helper";
import { Spin } from "antd";
import { post } from "../../../helpers/api_helper";
import swal from "sweetalert";
import CustomInput from "../../../CustomControls/CustomInput";
import { capitalizeString, errorMessage } from "../CommonFunctions";

const QuickAddCategory = ({
  categoryType,
  parentCategoryID,
  showModal,
  setShowModal,
  categoryTypeName,
  fnCallback,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    CategoryID: Yup.number(),
    CategoryType: Yup.number(),
    CategoryName: Yup.string()
      .trim()
      .required(`${categoryTypeName} is required field`),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CategoryID: 0,
      CategoryType: categoryType,
      CategoryName: "",
      ParentCategoryID: parentCategoryID,
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formik;

  const handleValidSubmit = (values) => {
    const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
    setIsLoading(true);

    let payload = {
      CategoryType: categoryType,
      CategoryName: values.CategoryName.trim(),
      ParentCategoryID: parentCategoryID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(POST_CategoryInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response.IsSuccess) {
          fnCallback(response?.CategoryID, values.CategoryName.trim());
          formik.resetForm();
          setShowModal(false);
          setIsLoading(false);
        } else {
          //swal("Error!", response.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <Modal className="fade" show={showModal} onHide={setShowModal}>
      <Spin
        size="large"
        spinning={isLoading}
        tip={"Loading..."}
        style={{ position: "fixed" }}
      >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Header>
              <Modal.Title>{categoryTypeName}</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => {
                  formik.resetForm();
                  setShowModal(false);
                }}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <Field
                    type="text"
                    label={categoryTypeName}
                    name="CategoryName"
                    placeholder={`Enter ${categoryTypeName}`}
                    component={CustomInput}
                    maxLength={250}
                    required
                    autoFocus
                    onChange={(e) => {
                      formik.setFieldValue(
                        "CategoryName",

                        categoryType != 8
                          ? capitalizeString(e?.target?.value)
                          : e?.target?.value,
                      );
                    }}
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                // variant="primary"
                variant="primary btn-sm"
                type="submit"
              >
                <i className="fa-solid fa-floppy-disk"></i> Submit
              </Button>
              <Button
                // variant="danger light"
                variant="danger btn-sm"
                onClick={() => {
                  formik.resetForm();
                  setShowModal(false);
                }}
              >
                <i className="fa fa-cancel"></i> Cancel
              </Button>
            </Modal.Footer>
          </Form>
        </FormikProvider>
      </Spin>
    </Modal>
  );
};

export default QuickAddCategory;
